import React, { FC } from 'react';

import EventRegistration from '@buyside/components/presentation/EventPage/EventRegistration/eventRegistration';
import FadeInContainer from '@buyside/components/presentation/FadeInContainer/fadeInContainer';

import styles from './eventDescriptionStyles.scss';

const EventDescription: FC<{ isLoggedIn: boolean }> = ({ isLoggedIn }) => (
  <div id="description" className={styles.descriptionContainer}>
    <div className={styles.descriptionCopy}>
      <div className={styles.sectionEyebrow}>Overview</div>
      <hr className={styles.sectionDivider} />
      <h4 className={styles.descriptionLead}>
        A private, candid dinner for investors to exchange differentiated ideas, challenge
        consensus, and build relationships with peers.
      </h4>
      <FadeInContainer>
        <p className={styles.descriptionText}>
          AlphaSense and SumZero are hosting a highly curated evening for a select group of buyside
          investors at AlphaSense's new Hudson Yards headquarters. It is designed as a private
          investor dinner built around candid discussion, actionable market perspectives, and
          high-quality peer exchange.
        </p>
      </FadeInContainer>
    </div>
    <EventRegistration isLoggedIn={isLoggedIn} />
  </div>
);

export default EventDescription;
